


















import Vue from 'vue';

export default Vue.extend({
  name: 'TitleWithModalCellPresenter',
  methods: {
    openModal() {
      // Don't ask me why, but this is the only way to get this working.
      // ObjectInfoSpaWrapper won't accept more attributes in 'data'...
      const combined = this.$attrs.row.__typename + ':' + this.$attrs.row.dbId;
      window.GGRC.zenModal.show({
        type: 'ObjectInfoSpaWrapper',
        data: {
          id: combined,
        },
        context: this.$attrs['table-id'],
      });
    },
  },
});
